module.exports = __webpack_public_path__ + "static/media/sales.0af20927.svg";